import { snakeCase } from 'change-case';

import Base from 'app/views/base';

import SubItemsListView from '../sub_items_list';
import ObjectDetailsView from '../object_details';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .list__body__item__show_details': 'toggleDetails',
    'click .list__body__item__heading': 'clickHeading',
  },

  initialize({ headings = [], showDetails = false, subItems = false }) {
    this.headings = headings;
    this.showDetails = showDetails;
    this.DetailsView = showDetails.DetailsView || ObjectDetailsView;
    this.subItems = subItems;
    this.uid = parseInt(Math.random() * 100000, 10);

    this.headings.forEach(heading => {
      if (heading.subView) {
        const subView = heading.subView(this.model);
        const id = this.model.get('id');
        const subviewName = this.computeHeadingId(id, heading.display);

        if (!this.getSubview(subviewName)) {
          this.addSubview(
            subviewName,
            `#${subviewName}`,
            subView
          );
        }
      }
    });

    if (this.subItems) {
      this.addSubview('subItems', `#${this.uid}-subitems`, new SubItemsListView({
        headings: this.subItems.headings,
        collection: this.model.get(this.subItems.property),
      }));
    }

    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    return {
      model: this.model,
      headings: this.headings,
      showDetails: this.showDetails,
      subItemsArray: this.model.get(this.subItems.property) || [],
      uid: this.uid,
      computeDetailsId: this.computeDetailsId.bind(this),
      computeHeadingId: this.computeHeadingId.bind(this),
      getTextFromHeading: this.getTextFromHeading,
    };
  },

  getTextFromHeading(model, heading) {
    if (heading.text) {
      if (typeof heading.text === 'function') {
        return heading.text(model);
      }

      return heading.text;
    }

    const prop = heading.property;

    if (typeof model[prop] === 'function') {
      return model[prop]();
    }

    return model.get(prop);
  },

  computeId(id) {
    return `${this.uid}-model-${id}`;
  },

  computeHeadingId(id, display) {
    return `${this.computeId(id)}-${snakeCase(display)}`;
  },

  computeDetailsId(id) {
    return this.computeId(id) + '-details';
  },

  toggleDetails(e) {
    e.preventDefault();

    const detailsSelector = '.list__body__item__details';

    const subviewName = this.computeDetailsId(this.model.get('id'));
    if (this.$(detailsSelector).is(':visible')) {
      this.removeSubview(subviewName);
    } else {
      this.addSubview(
        subviewName,
        `#${subviewName}`,
        new this.DetailsView({ model: this.model, showDetails: this.showDetails })
      );

      this.render();
    }

    this.$(detailsSelector).toggle();
  },

  clickHeading(e) {
    const headingIndex = $(e.currentTarget).data().headingIndex;

    if (this.headings[headingIndex].onClick) {
      e.preventDefault();
      this.headings[headingIndex].onClick(this.model);
    }
  }
});



// WEBPACK FOOTER //
// ./app/components/list/item/index.js